// extracted by css-extract-rspack-plugin
export default {"searchContainer":"DashboardSearch-module__searchContainer___Vx6P","actions":"DashboardSearch-module__actions__XoLqp"};